module.exports = new __parcel__URL__("lego.58307dda.avif").toString();